import { render } from "./Vision.vue?vue&type=template&id=35a0848c"
import script from "./Vision.vue?vue&type=script&lang=js"
export * from "./Vision.vue?vue&type=script&lang=js"
script.render = render

export default script